<template>
	<v-list-item class="mb-0 justify-space-between pl-3">
		<a href="/" target="_blank">
			<img src="/logo.png" style="max-width: 100px;max-height: 50px;" />
		</a>
		<v-list-item-content class="pl-2">
			<v-list-item-title class="text-h3">
				<strong class="mr-1 font-weight-black">{{ titlePart1 }}</strong>
				<span class="primary--text">{{ titlePart2 }}</span>
				<user-full-name />
				<national-code />
			</v-list-item-title>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
// Utilities
import { get } from 'vuex-pathify'
import UserFullName from '@/components/Username'
import NationalCode from '@/components/NationalCode'

export default {
	name: 'DefaultDrawerHeader',
	components: {
		UserFullName,
		NationalCode,
	},
	computed: {
		version: get('app/version'),
		...get('siteConfig', [
			'isCloud', 'fullTitle', 'titlePart1', 'titlePart2'
		]),
	},
	methods: {

	}
}
</script>
